<template>
  <div class="main-header__top d-sm-none container">
    <div class="main-header__top-menu-mob select-dropdown  _left">
      <button type="button"
              class="base-link user-bar__link"
              @click.prevent="onOpenTopMenu"
      >
        <BaseSvg name="ico-dots-2"
                 width="1.6rem"
                 height=".4rem"
                 style="margin-top: .2rem"
                 class="base-link__ico"/>
        <span class="base-link__text">{{ $tHeader('More') }}</span>
      </button>
      <transition name="dropdown">
        <div v-if="isTopMenuOpen"
             v-click-out="onCloseTopMenu"
             class="select-dropdown__dropdown">
          <button type="button"
                  class="select-dropdown__close"
                  @click.prevent="onCloseTopMenu"
          >
            <BaseSvg name="ico-close"
                     width=".8rem"
                     height=".8rem"/>
          </button>
          <div class="select-dropdown__options user-bar">
            <div class="user-bar__item">
              <router-link-modified :to="{name: 'about'}"
                                    tag="a"
                                    class="base-link user-bar__link">
                <BaseSvg name="ico-question"
                         width="1.5rem"
                         height="1.5rem"
                         class="base-link__ico"/>
                <span class="base-link__text">{{ $tHeader('About company') }}</span>
              </router-link-modified>
            </div>
            <div class="user-bar__item d-none _show-besides-lg-md d-md-flex">
              <router-link-modified :to="{name: 'vacancies'}"
                                    tag="a"
                                    class="base-link user-bar__link">
                <BaseSvg name="ico-list-2"
                         width="1.7rem"
                         height="1.5rem"
                         class="base-link__ico"/>
                <span class="base-link__text">{{ $tHeader('All vacancies') }}</span>
              </router-link-modified>
            </div>
            <div class="user-bar__item">
              <router-link-modified :to="{name: 'news-page'}"
                                    tag="a"
                                    class="base-link user-bar__link">
                <BaseSvg name="ico-page"
                         width="1.4rem"
                         height="1.7rem"
                         class="base-link__ico"/>
                <span class="base-link__text">{{ $tHeader('News') }}</span>
              </router-link-modified>
            </div>
          </div>
        </div>
      </transition>
    </div>


    <div class="main-header__top-menu  user-bar">
      <div class="user-bar__item  d-lg-none">
        <router-link-modified :to="{name: 'about'}"
                              class="base-link user-bar__link">
          <BaseSvg name="ico-question"
                   width="1.5rem"
                   height="1.5rem"
                   class="base-link__ico"/>
          <span class="base-link__text">{{ $tHeader('About company') }}</span>
        </router-link-modified>
      </div>
      <div class="user-bar__item  _hide-besides-lg-md  d-md-none">
        <router-link-modified :to="{name: 'vacancies'}"
                              tag="a"
                              class="base-link user-bar__link">
          <BaseSvg name="ico-list-2"
                   width="1.7rem"
                   height="1.5rem"
                   class="base-link__ico"/>
          <span class="base-link__text">{{ $tHeader('All vacancies') }}</span>
        </router-link-modified>
      </div>

      <!--   TODO temporary hide services menu   -->
      <div
        v-if="false"
        class="main-header__top-menu select-dropdown  _left"
      >
        <button type="button"
                class="base-link user-bar__link"
                @click.prevent="isTopMenuServicesOpen = true"
        >
          <BaseSvg name="ico-services"
                   width="1.8rem"
                   height="1.7rem"
                   class="base-link__ico"/>
          <span class="base-link__text">{{ $tHeader('Services') }}</span>
        </button>
        <transition name="dropdown">
          <div v-if="isTopMenuServicesOpen"
               v-click-out="() => isTopMenuServicesOpen = false"
               class="select-dropdown__dropdown">
            <button type="button"
                    class="select-dropdown__close"
                    @click.prevent="isTopMenuServicesOpen = false"
            >
              <BaseSvg name="ico-close"
                       width=".8rem"
                       height=".8rem"/>
            </button>
            <div class="select-dropdown__options  header-drop-menu">
              <div v-for="service in servicesList"
                   :key="service.slug"
                   :class="service.enabled ? null : '_disabled'"
                   class="header-drop-menu__item">
                <router-link-modified v-if="service.enabled"
                                      :to="formatClientLink(service.link) || {name: 'service', params: {id: service.slug}}"
                                      @click.native="isTopMenuServicesOpen = false"
                                      class="header-drop-menu__link">
                  <div :style="`background-image: url(${service.small_icon})`"
                       class="header-drop-menu__link-ico"></div>
                  <span>{{ $get(service, `name_trans.${currentLocale}`) || service.name }}</span>
                </router-link-modified>
                <div v-else
                     class="header-drop-menu__link">
                  <div :style="`background-image: url(${service.small_icon})`"
                       class="header-drop-menu__link-ico"></div>
                  <span>{{ $get(service, `name_trans.${currentLocale}`) || service.name }}</span>
                </div>

                <div class="header-drop-menu__sub-links">
                  <router-link-modified v-for="child in service.childs"
                                        :key="child.slug"
                                        :to="formatClientLink(child.link) || {name: 'service', params: {id: service.slug, childId: child.slug}}"
                                        @click.native="isTopMenuServicesOpen = false"
                                        class="header-drop-menu__sub-link">
                    {{ $get(child, `name_trans.${currentLocale}`) || child.name }}
                  </router-link-modified>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="user-bar__item  d-lg-none">
        <router-link-modified :to="{name: 'news-page'}"
                              tag="a"
                              class="base-link user-bar__link">
          <BaseSvg name="ico-page"
                   width="1.4rem"
                   height="1.7rem"
                   class="base-link__ico"/>
          <span class="base-link__text">{{ $tHeader('News') }}</span>
        </router-link-modified>
      </div>

      <div v-if="!isLogged" class="user-bar__auth-wrap">
        <BaseSvg name="ico-case"
                 width="1.7rem"
                 height="1.8rem"
                 class="user-bar__auth-ico"/>
        <router-link-modified :to="{name: 'for-employers'}"
                              tag="div"
                              class="user-bar__auth-link">
          {{ $tHeader('For employers') }}
        </router-link-modified>
      </div>
    </div>

    <div class="main-header__select-bar user-bar">
      <div class="user-bar__item">
        <div class="select-dropdown">
          <button type="button"
                  class="select-dropdown__trigger"
                  @click.prevent="onOpenCurrencyDropdown">
            <span class="select-dropdown__trigger-label  d-md-none">{{ $tHeader('Currency') }}</span>
            <span v-if="currentCurrency.currency === 'ALL'"
                  class="select-dropdown__trigger-current">
              {{ $tGlobal('currency_all') }}
            </span>
            <span v-else
                  class="select-dropdown__trigger-current">
              {{ currentCurrency.currency }} / {{ currentCurrency.symbol }}
            </span>
            <BaseSvg name="ico-arrow"
                     class="select-dropdown__trigger-arrow"/>
          </button>
          <transition name="dropdown">
            <div v-if="isCurrencyDropdownOpen"
                 v-click-out="onCloseCurrencyDropdown"
                 class="select-dropdown__dropdown">
              <button type="button"
                      class="select-dropdown__close"
                      @click.prevent="onCloseCurrencyDropdown"
              >
                <BaseSvg name="ico-close"
                         width=".8rem"
                         height=".8rem"/>
              </button>
              <div class="select-dropdown__options">
                <a v-for="item in currencies"
                   :key="item.id"
                   :href="`#${item.currency}`"
                   @click.prevent="onSelectCurrency(item)"
                   class="select-dropdown__option"
                   :class="{'_active': currentCurrency === item}"
                >
                  <span v-if="item.currency === 'ALL'">{{ $tGlobal('currency_all') }}</span>
                  <span v-else>{{ item.currency }} / {{ item.symbol }}</span>
                </a>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="user-bar__item">
        <div class="select-dropdown _locale">
          <button type="button"
                  class="select-dropdown__trigger"
                  @click.prevent="onOpenLocaleDropdown">
            <span class="select-dropdown__trigger-label  d-md-none">{{ $tHeader('Language') }}</span>
            <span class="select-dropdown__trigger-current">{{ currentLocale }}</span>
            <img :src="currentLocaleObject.flag"
                 :alt="currentLocale"
                 class="select-dropdown__trigger-ico">
            <BaseSvg name="ico-arrow"
                     class="select-dropdown__trigger-arrow"/>
          </button>
          <transition name="dropdown">
            <div v-if="isLocaleDropdownOpen"
                 v-click-out="onCloseLocaleDropdown"
                 class="select-dropdown__dropdown">
              <button type="button"
                      class="select-dropdown__close"
                      @click.prevent="onCloseLocaleDropdown"
              >
                <BaseSvg name="ico-close"
                         width=".8rem"
                         height=".8rem"/>
              </button>
              <div class="select-dropdown__options">
                <router-link v-for="item in locales"
                             :key="item.id"
                             :to="getRoute(item)"
                             @click.native="onSelectLocale(item)"
                             class="select-dropdown__option">
                  <span>{{ item.key }}</span>
                  <img :src="item.props.flag"
                       :alt="item.key"
                       class="select-dropdown__trigger-ico">
                </router-link>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <HeaderUserPanel class="main-header__user-panel"/>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
  import HeaderUserPanel from './HeaderUserPanel'

  export default {
    name: 'HeaderTop',
    components: {HeaderUserPanel},
    data() {
      return {
        isCurrencyDropdownOpen: false,
        isLocaleDropdownOpen: false,
        isTopMenuOpen: false,
        isTopMenuServicesOpen: false,
        appLink: globalConfigs.header.app_link,
      }
    },
    computed: {
      ...mapState([
        'currencies',
        'currentCurrency',
        'currentLocale',
        'defaultLocale',
      ]),
      ...mapGetters('user', [
        'isLogged',
      ]),

      locales() {
        const storeLocales = this.$store.state.locales
        const locales = []

        for (let key in storeLocales) {
          locales.push({
            key,
            props: storeLocales[key]
          })
        }
        //console.log(locales)
        return locales
      },
      currentLocaleObject() {
        return this.$store.state.locales[this.currentLocale]
      },
      servicesList() {
        const services_list = [...globalConfigs.services_list].filter(service => service.slug !== 'company-info')
        if (window.location.hostname === 'jobian.com') {
          return services_list
        }

        return [
          ...services_list,
          {
            enabled: 1,
            link: "/payment-account/",
            name: "Jobian Pay",
            name_trans: {
              ua: "Jobian Pay",
              ru: "Jobian Pay",
              en: "Jobian Pay",
              pl: "",
              lt: ""
            },
          },
          {
            enabled: 1,
            link: "/payment-transfer/",
            name: "Jobian Pay transfer",
            name_trans: {
              ua: "Jobian Pay transfer",
              ru: "Jobian Pay transfer",
              en: "Jobian Pay transfer",
              pl: "",
              lt: ""
            },
          }]
      }
    },
    methods: {
      onOpenCurrencyDropdown() {
        this.isCurrencyDropdownOpen = true
      },
      onCloseCurrencyDropdown() {
        this.isCurrencyDropdownOpen = false
      },
      onOpenLocaleDropdown() {
        this.isLocaleDropdownOpen = true
      },
      onCloseLocaleDropdown() {
        this.isLocaleDropdownOpen = false
      },
      onOpenTopMenu() {
        this.isTopMenuOpen = true
      },
      onCloseTopMenu() {
        this.isTopMenuOpen = false
      },
      onSelectCurrency(item) {
        this.$store.dispatch('changeCurrentCurrency', item)
        this.onCloseCurrencyDropdown()
      },
      onSelectLocale(item) {
        const currentLocale = this.locales.find(locale => locale.key === item.key)
        if (currentLocale) {
          this.$store.dispatch('changeCurrentLocale', item.key)
          this.onCloseLocaleDropdown()
        }
      },
      getRoute(item) {
        let name = this.$route.name

        if (item.key === 'ua') {
          if (!name.endsWith('-double')) {
            name += '-double'
          }

          return {
            name,
            params: {...this.$route.params, lang: item.key},
            query: {...this.$route.query}
          }
        } else {
          if (name.endsWith('-double')) {
            name = name.replace('-double', '')
          }

          return {
            name,
            params: {...this.$route.params, lang: item.key},
            query: {...this.$route.query}
          }
        }
      },
      formatClientLink(link) {
        if (!link) return null

        if (link.startsWith('http')) {
          return link
        }

        if (!link.startsWith('/')) {
          link = '/' + link
        }

        if (this.defaultLocale === this.currentLocale) {
          return link
        }

        return `/${this.currentLocale}${link}`
      }
    }
  }
</script>

<style>

</style>
